import { useState } from "react";
import Button from "./Button";
import { ReactComponent as SearchIcon } from "../../assets/icons/search.svg";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { useDispatch } from "react-redux";
import FilterModel from "./filterModel";

const Searching = (props) => {
  const [search, setSearch] = useState("");
  const [error, setError] = useState({ hashtag: "" });
  const [hashtags, setHashTag] = useState("");
  const {
    start,
    limit,
    startDate,
    endDate,
    data,
    setData,
    type,
    serverSearching,
    setSearchData,
    placeholder,
    button,
    newClass,
    btnShow,
    actionShow,
    paginationSubmitButton,
    setActionPagination,
    actionPagination,
    actionEnteries,
    setActionEnteries,
    customEnteriesData,
    handleRowsPerPage,
    customSelectDataShow,
    customeSelectDataEnteriesShow,
    customSelectData,
    label,
    actionPaginationDataCustom,
    typeIsTag,
    //filter
    customeFilterData,
    customFilterDataShow,
    actionFilter,
    setActionFilter,
    handleFilterData,
    actionFilterHandle,
    firstField,
    firstFieldName,
    secondField,
    secondFieldName,
    ModelName,
    feature,
    options,
    hasActiveFilters,
    setHasActiveFilters,
    filterType,
    setFilter,
  } = props;
  const dispatch = useDispatch();
  const handleSearch = (event) => {
    event.preventDefault();

    let searchValue = search ? search : event?.target?.value?.toLowerCase();
    const getLowerCaseSearch = searchValue?.toLowerCase();

    if (getLowerCaseSearch !== undefined) {
      if (type === "client") {
        if (getLowerCaseSearch) {
          const filteredData = data.filter((item) => {
            return Object.keys(item).some((key) => {
              if (key === "_id" || key === "updatedAt" || key === "createdAt") {
                return false;
              }
              const itemValue = item[key];
              if (typeof itemValue === "string") {
                return itemValue.toLowerCase().indexOf(getLowerCaseSearch) > -1;
              } else if (typeof itemValue === "number") {
                return itemValue.toString().indexOf(getLowerCaseSearch) > -1;
              } else if (typeof itemValue === "object" && itemValue !== null) {
                // Check for nested object (agencyId) and handle nested properties
                return Object.values(itemValue).some((nestedValue) => {
                  if (typeof nestedValue === "string") {
                    return (
                      nestedValue.toLowerCase().indexOf(getLowerCaseSearch) > -1
                    );
                  }
                  return false;
                });
              }
              return false;
            });
          });
          setData(filteredData); // Update the filteredData state
        } else {
          setData(data); // Reset the filteredData state to the original data
        }
      } else {
        // For other types, implement the serverSearching function
        serverSearching ? serverSearching(searchValue) : "";
      }
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSearch(e);
    }
  };
  const handleChange = (event) => {
    setHashTag(event.target.value);
  };
  const handleFocus = () => {
    setError({
      ...error,
      hashtag: "",
    });
  };
  const handleSubmit = () => {
    if (hashtags == null) {
      setError({
        ...error,
        hashtag: "please provide hashtag",
      });
      return;
    }
    const check = hashtags.startsWith("#");
    if (!check) {
      setError({
        ...error,
        hashtag: "hashtag must start with #",
      });
      return;
    }

    dispatch(props.addHashtag(hashtags, start, limit));

    setHashTag("");
  };
  const paginationActionData = actionPaginationDataCustom
    ? actionPaginationDataCustom
    : ["Block", "Unblock", "Delete"];

  return (
    <>
      <div className="row search-action h-120" style={{ paddingRight: "3px" }}>
        <div className="d-flex  col-12 col-lg-6 col-md-6 col-sm-12 ">
          <div className=" searching-box " style={{ float: "right" }}>
            <div
              className={`prime-input search-input-box  m-0 ${newClass}`}
              style={{ borderRadius: "62px" }}
            >
              <label
                className="mb-3 mt-3"
                style={{ fontSize: "15px", fontWeight: "400", color: "unset" }}
              >
                {label}
              </label>

              <input
                type="search"
                autoComplete="false"
                placeholder={placeholder}
                aria-describedby="button-addon4"
                className="form-input searchBarBorderr "
                style={{
                  borderRadius: "62px",
                  borderBottomRightRadius: "0px",
                  borderTopRightRadius: "0px",
                  height: "56px",
                  paddingLeft: "20px",
                }}
                onChange={(e) => {
                  const inputValue = e.target.value;
                  if (!inputValue) {
                    handleSearch(e);
                    serverSearching ? setSearchData("") : setData(data);
                  }
                  handleSearch(e);
                }}
                onKeyPress={handleKeyPress}
              />

              {button && (
                <Button
                  type="button"
                  btnIcon={<SearchIcon />}
                  newClass={`themeBtn text-center fs-6  searchBtn text-white `}
                  onClick={(e) => handleSearch(e)}
                />
              )}
            </div>
          </div>
          {customFilterDataShow && (
            <div
              className="pagination-select  d-flex justify-content-start ms-2"
              style={{ width: "30%" }}
            >
              <div className="pagination-submit">
                {/* <FormControl>
                  <InputLabel
                    id="demo-simple-select-label"
                    style={{
                      fontWeight: "500",
                      fontSize: "17px",
                      marginBottom: "10px",
                    }}
                  >
                    Filter
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={actionFilter}
                    label="Filter"
                    onChange={(e) => {
                      setActionFilter(e.target.value);
                      actionFilterHandle(e.target.value);
                    }}
                  >
                    {customFilterDataShow
                      ? customeFilterData?.map((item) => {
                          return (
                            <MenuItem value={item} key={item}>
                              {item}
                            </MenuItem>
                          );
                        })
                      : ""}
                  </Select>
                </FormControl> */}
                <FilterModel
                  firstField={firstField}
                  firstFieldName={firstFieldName}
                  secondField={secondField}
                  secondFieldName={secondFieldName}
                  ModelName={FilterModel}
                  feature={feature}
                  options={options}
                  hasActiveFilters={hasActiveFilters}
                  setHasActiveFilters={setHasActiveFilters}
                  filterType={filterType}
                  start={start}
                  limit={limit}
                  startDate={startDate}
                  endDate={endDate}
                  setFilter={setFilter}
                />
              </div>
            </div>
          )}
        </div>
        <div className="col-12 col-lg-6 col-md-6 col-sm-12  pagination-select p-0">
          <div className="d-flex flex-column justify-content-end w-100 pagination-box">
            <div className="d-flex align-items-center justify-content-end">
              <div className="pagination-submit me-3">
                <div className="d-flex ">
                  {actionShow === false ? (
                    ""
                  ) : (
                    <div className="w-100 ">
                      <FormControl>
                        <InputLabel
                          id="demo-simple-select-label"
                          style={{
                            fontWeight: "500",
                            fontSize: "17px",
                            marginBottom: "10px",
                          }}
                        >
                          Action
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value={actionPagination}
                          label="Action"
                          onChange={(e) => setActionPagination(e.target.value)}
                        >
                          {customSelectDataShow
                            ? customSelectData?.map((item) => {
                                return (
                                  <MenuItem
                                    value={item?.toLowerCase()}
                                    key={item}
                                  >
                                    {item}
                                  </MenuItem>
                                );
                              })
                            : paginationActionData?.map((item) => {
                                return (
                                  <MenuItem
                                    value={item?.toLowerCase()}
                                    key={item}
                                  >
                                    {item}
                                  </MenuItem>
                                );
                              })}
                        </Select>
                      </FormControl>
                    </div>
                  )}
                </div>
              </div>
              {actionShow === false ? (
                ""
              ) : (
                <Button
                  newClass={"submit-btn-dialogue py-2"}
                  onClick={paginationSubmitButton}
                  btnName={"Submit"}
                  style={{ marginRight: "10px" }}
                />
              )}
            </div>

            {/*typeIsTag && (
              <>
                <div className="pt-3 d-flex">
                  <input
                    type="text"
                    autoComplete="false"
                    placeholder="Hashag must start with #"
                    aria-describedby="button-addon4"
                    className="form-input searchBarBorderr "
                    onChange={handleChange}
                    onFocus={handleFocus}
                    value={hashtags}
                    style={{
                      borderRadius: "62px",
                      borderBottomRightRadius: "62px",
                      borderTopRightRadius: "62px",
                      height: "56px",
                      paddingLeft: "20px",
                      marginRight: "15px",
                      marginLeft: "46px",
                    }}
                    onKeyPress={handleKeyPress}
                  />
                  <Button
                    newClass={"submit-btn-dialogue py-2"}
                    btnName={"Add"}
                    style={{ marginLeft: "10px" }}
                    onClick={handleSubmit}
                  />
                </div>

                <div>
                  {error.hashtag && (
                    <p className="errorMessage" style={{ paddingLeft: "68px" }}>
                      {error.hashtag && error.hashtag}
                    </p>
                  )}
                </div>
              </>
            )*/}
          </div>
        </div>
      </div>
    </>
  );
};

export default Searching;
